import { getAuthData, login } from '../AuthService';
import { _sendReply } from '../Communication';
import { writeFile } from '../Filesystem/Helper';
import { registerHandler } from '../MessageManager';

import { requestDataSources } from './SessionService';

import { pConServiceProvider } from '@egr/xbox/pcon-login-api/ServicesProvider';
import { getCachedValue } from '@egr/xbox/utils/Cache';
import { getContent } from '@egr/xbox/utils/Download';
import { getEnvBoolean, getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';
import { Logger } from '@egr/xbox/utils/errors/Logger';

import { GatekeeperClient } from '@easterngraphics/gatekeeper-lib';
import { isNotNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

async function getSession() {
    const gatekeeperClient = getCachedValue(getSession, () => {
        return new GatekeeperClient({
            serviceProvider: pConServiceProvider
        });
    });
    const accessToken = await login();
    return gatekeeperClient.openSession(getEnvVar('GATEKEEPER_ID')!, {
        applicationId: getEnvVar('PCON_LOGIN_CLIENT_ID'),
        userToken: !getEnvBoolean('IGNORE_PACKAGE_GROUPS', false) ? accessToken.access_token : undefined
    });
}

/**
 * Note: only supports OBK files for now
 */
async function getOpenFile() {
    const url = getEnvVar('DEBUG_OPEN_FILE');
    if (isNotNullOrEmpty(url)) {
        const content = await getContent(url, 'arraybuffer');
        if (content != null) {
            const filename = `/import/${Date.now()}.obk`;
            await writeFile(filename, content);

            return {
                path: filename,
                type: 'obk'
            };
        }
    }

    return undefined;
}

export function registerDebugInformation(): void {
    registerHandler({
        type: 'information',
        callback: async (event: MessageEvent): Promise<void> => {
            switch (event.data.action) {
                case 'app_info':
                        let authData = await getAuthData();
                        if (authData.access_token === '') {
                            authData = await login(true);
                        }
                        const dataSources = await requestDataSources(authData.access_token);
                    _sendReply(
                        event.data.transaction_id,
                        false,
                        {
                            api_version: {
                                major: 1,
                                minor: 4,
                            },
                            app_version: {
                                major: 0,
                                minor: 0,
                                build: 0,
                                patch: 0
                            },
                            app_protocol: '',
                            ar_device: getEnvVar('DEBUG_AR_STREAM', '').startsWith('http'),
                            initialization_url: document.location.href,
                            production_url: document.location.href,
                            project_count: 3,
                            session: getEnvVar('ID') === 'facts' ? await getSession() : undefined,
                            openFile: await getOpenFile(),
                            insets: {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                            },
                            availableDataSources: dataSources,
                            activeDataSource: dataSources.find((source) => source.id === getEnvVar('GATEKEEPER_ID'))
                        }
                    );
                    break;
                case 'webview_dimensions':
                    _sendReply(
                        event.data.transaction_id,
                        false,
                        {
                            height: window.innerHeight,
                            width: window.innerWidth
                        }
                    );
                    break;
                default:
                    if (event.data.transaction_id !== -1) {
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        _sendReply(event.data.transaction_id, true, `Unsupported app action: ${event.data.action}`);
                    } else {
                        Logger.warn('Unsupported app action:', event.data.action);
                    }
                    break;
                case 'import_project': {
                    _sendReply(
                        event.data.transaction_id,
                        false,
                        {
                            undefined
                        }
                    );
                    break;
                }
            }
        }
    });
}